// const getDescendantValues = (record, dataIndex) => {
//   const values = [];
//   (function recurse(record) {
//     values.push(record[dataIndex].toString().toLowerCase());
//     record.children.forEach(recurse);
//   })(record);
//   return values;
// };

function expandSubsidiaryChildren(children, key) {
  return children.map((data, i) => {
    if (data.children && data.children.length !== 0) {
      return {
        ...data,
        loc: data.loc || '-',
        key: `${key}-${i}`,
        children: expandSubsidiaryChildren(data.children, `${key}-${i}`),
      };
    }
    return {
      ...data,
      loc: data.loc || '-',
      key: `noChild-${key}-${i}`,
    };
  });
}

function addRowKey(originData) {
  if (!originData) {
    return [];
  }
  return originData.map((data, index) => {
    if (data.children?.length !== 0) {
      return {
        ...data,
        loc: data.loc || '-',
        key:
          data.children && data.children.length !== 0
            ? `${index}`
            : `noChild-${index}`,
        children: expandSubsidiaryChildren(data.children, index),
      };
    }
    return {
      ...data,
      loc: data.loc || '-',
      key:
        data.children && data.children.length !== 0
          ? `${index}`
          : `noChild-${index}`,
      // children: data.branchList,
    };
  });
}

const subsidiaryColumnFilterName = [
  'companyName',
  'type',
  'duns',
  'completeLoc',
  'loc',
  'share',
];
const officeColumnFilterName = ['countryName', 'state', 'city', 'share'];
const arrayToObject = (sum, current) => {
  sum[current] = new Set();
  return sum;
};

function getFilterOptions(list, fields) {
  if (!list) {
    return null;
  }
  const collector = fields.reduce(arrayToObject, {});
  function recurse(record) {
    fields.forEach((field) => {
      if (record[field] || field === 'share') {
        collector[field].add(record[field]);
      }
    });
    if (record.children && record.children.length) {
      record.children.forEach(recurse);
    }
  }
  list.forEach(recurse);

  for (const collectorKey in collector) {
    collector[collectorKey] = Array.from(collector[collectorKey]);
  }

  return collector;
}

/**
 * add keys and generate option data for filters
 * @param data
 * @returns {*}
 */
export function processSubsidiaries(data) {
  ['grid', 'futureGrid'].forEach((i) => {
    if (data[i] && Array.isArray(data[i])) {
      data[i].forEach((companyData) => {
        if (companyData?.subsidiaries) {
          companyData.subsidiaries = addRowKey(companyData.subsidiaries);
        }
        const subsidiaryFilterOptions = getFilterOptions(
          companyData?.subsidiaries,
          subsidiaryColumnFilterName,
        );
        const officeFilterOptions = getFilterOptions(
          companyData?.officeLocations,
          officeColumnFilterName,
        );

        companyData.subsidiaryFilterOptions = subsidiaryFilterOptions;
        companyData.officeFilterOptions = officeFilterOptions;
      });
    }
  });
  return data;
}
